import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-arrow-up",
  templateUrl: "./arrow-up.component.html",
  styleUrls: ["./arrow-up.component.scss"],
})
export class ArrowUpComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
